import {isIde} from "../../misc/envNameUtils.ts";

export const getModelReasoningEffort = (model: string, claude_sonnet_reasoning_effort: string, claude_opus_reasoning_effort: string, contextDetails: any, environment: string) => {
    const getReasoningEffortForNumTurns = (numberOfTurns: number) => {
        if (model.includes("Claude")) {
            if (isIde(environment) || environment === "chrome") return "None"
            else return "None";
        }
        else {
            if (numberOfTurns <= 1) {
                return "Medium";
            } else if (numberOfTurns <= 4) {
                return "Medium";
            } else {
                return "Low";
            }
        }
    }

    if (model === "Claude-Sonnet") {
        if (claude_sonnet_reasoning_effort === "Automatic") return getReasoningEffortForNumTurns(contextDetails.numberOfTurns);
        return claude_sonnet_reasoning_effort;
    }
    else if (model === "Claude-Opus") {
        if (claude_opus_reasoning_effort === "Automatic") return getReasoningEffortForNumTurns(contextDetails.numberOfTurns);
        return claude_opus_reasoning_effort;
    }
    else return undefined;
}
